import React from 'react';
import {Block, Button, Columns} from 'react-bulma-components';
import {toWellPrintedJSON} from '../utils/json.utils';
import {showSuccessNotification} from '../utils/notification.utils';

interface Props {
    header: {[key: string]: any};
    payload: {[key: string]: any};
}

const renderBlock = (title: string, value: {[key: string]: any}): React.ReactElement => {
  const formattedValue = toWellPrintedJSON(value);

  return (
    <Block>
      <div className="is-flex is-align-items-center">
        <span className="mr-2">
          {title}
        </span>

        <Button
          text
          onClick={async () => {
            await navigator.clipboard.writeText(formattedValue);
            showSuccessNotification('Copied to clipboard');
          }}
        >
          Copy
        </Button>
      </div>

      <pre>
        {formattedValue}
      </pre>
    </Block>
  );
};

const DecodedJWS: React.FC<Props> = ({header, payload}) => {
  return (
    <Columns>
      <Columns.Column>
        {renderBlock('Header', header)}
      </Columns.Column>

      <Columns.Column>
        {renderBlock('Payload', payload)}
      </Columns.Column>
    </Columns>
  );
};

export default DecodedJWS;
